import { memo } from 'react'
import { useTranslation } from 'react-i18next'
import Skeleton from 'react-loading-skeleton'

const DATA_KEYS = {
  technical: 'technicalsByName',
  equipment: 'equipmentsByName',
}

const ROW_KEYS = {
  technical: 'allTechnicals',
  equipment: 'allEquipments',
}

const getAllRows = (type) => {
  const key = ROW_KEYS[type]

  if (!key) {
    return () => []
  }

  return (products = []) => {
    return products.reduce((result, { [key]: rows }) => {
      const filteredProducts = [...result, ...rows]

      return [...new Set(filteredProducts)]
    }, [])
  }
}

interface ComparisonBlockProps {
  type?: 'technical' | 'equipment'
  listProduct: Record<string, unknown>
  isLoading?: boolean
  isLoaded?: boolean
}

const ComparisonBlock = (props: ComparisonBlockProps) => {
  const { t } = useTranslation()
  const {
    type = 'technical',
    listProduct,
    isLoading = true,
    isLoaded = false,
  } = props
  const listProductIds = Object.keys(listProduct)
  const key = DATA_KEYS[type]

  const allRows = getAllRows(type)(Object.values(listProduct))

  const isEmpty = allRows.length === 0

  const isNotFound = isLoaded && isEmpty

  return (
    <>
      <tr>
        <td className="product-comparison-table__header" colSpan="4">
          <h4 className="font-weight-bold">{t(`productComparison.${type}`)}</h4>
        </td>
      </tr>
      {isLoading
        ? (
          <tr>
            <td>
              <Skeleton />
            </td>
            {listProductIds.map((productId) => (
              <td key={`skeleton-${productId}`}>
                <Skeleton />
              </td>
            ))}
          </tr>
        )
        : null}
      {isNotFound
        ? (
          <tr>
            <td>{t('productComparison.notFound')}</td>
          </tr>
        )
        : null}
      {allRows.map((dataKey) => {
        return (
          <tr key={dataKey}>
            <td>{dataKey}</td>
            {listProductIds.map((productId) => {
              const productData = listProduct[productId]

              let label = '————'

              if (productData?.[key]) {
                const value = productData[key][dataKey]

                if (value) {
                  label = value === true ? <span className="green-tick" /> : value
                }
              }
              return (
                <td
                  key={`${productId}-${dataKey}`}
                  className="font-weight-medium"
                >
                  {label}
                </td>
              )
            })}
          </tr>
        )
      })}
    </>
  )
}

export default memo(ComparisonBlock)
